// Copyright (C) 2021 TANNER AG

import gql from "graphql-tag";

export const FullEMobilityTopicsFragment = gql`
    fragment FullEMobilityTopicsFragment on EMobilityTopic {
        id
        title
        slug
        intro
        order
        active
        thumbnail(locales: [$lang, de]) {
            handle
            fileName
            width
            height
            url
            mimeType
        }
        eMobilityChapters {
            id
            order
            slug
            title
        }
    }
`;

export default gql`
    query EMobilityTopics($lang: Locale!, $stage: Stage!) {
        eMobilityTopics(locales: [$lang], stage: $stage, orderBy: order_ASC) {
            ...FullEMobilityTopicsFragment
        }
    }
    ${FullEMobilityTopicsFragment}
`;



// WEBPACK FOOTER //
// ./src/queries/eMobilityTopics.js